// @ts-check
import R from "../strings";
import { Component } from "../engine";
import { Vector2D } from "../engine/vector";
import { Graphics, Rect, Align } from "../engine/graphics";
import { GAMETYPE_TIME, GAMETYPE_BEST_OF, EVENT_INGAME_MATCHBALL, LOGIC_GAME_INTRO, LOGIC_GAME_FINISHED, EVENT_INGAME_SCORE_UPDATED, EVENT_GAME_RESET } from "../global";

/**
 * Constants
 */
const ANIM_PLAYER1_SCORE = 0x01;
const ANIM_PLAYER1_MATCHES = 0x02;
const ANIM_PLAYER2_SCORE = 0x10;
const ANIM_PLAYER2_MATCHES = 0x20;

/**
 * Game Renderer HUD
 */
export class GameRendererHUD extends Component {
    constructor() {
        super();
        this.rect = new Rect(0, 0, 0, 0);
        this.temp = new Vector2D(0, 0);
    }

    init() {
        // Load misc
        this.t = 0;
        this.matchball = R.matchball;

        // Load drawables
        this.drawableScore = new Graphics("score");

        // Load paints
        this.paintFont = { fillColor: "#00ff66", strokeWidth: 3, strokeColor: "#172b4a" };
        this.paintFontSelected = { fillColor: "#ff0066", strokeWidth: 3, strokeColor: "#172b4a" };
    }

    handleEvent(event) {
        // Handle event
        switch (event.type) {
            case EVENT_GAME_RESET:
                this.player1Score = -1;
                this.player2Score = -1;
                this.player1Matches = -1;
                this.player2Matches = -1;
            case EVENT_INGAME_SCORE_UPDATED:
                this.updateScore(this.state);
                break;
            case EVENT_INGAME_MATCHBALL:
                this.matchballAnim = 30;
                break;
        }
    }

    update() {
        // Inc t
        this.t += 1;

        // Update points zoom
        if (this.scoreAnimZoom > 0) {
            this.scoreAnimZoom -= 1;
        } else {
            this.scoreAnimZoom = 0;
        }

        // Update matchball anim
        if (this.matchballAnim > 0) {
            this.matchballAnim--;
        }

        // Update score
        if (this.player1ScoreString == undefined || this.player2ScoreString == undefined) {
            this.updateScore(this.state);
        }

        // Update timer
        var time = this.state.time;
        var minutes = Math.floor(time / 1000 / 60);
        var seconds = Math.floor((time / 1000) % 60);
        if (this.timeString == undefined || this.minutes != this.lastMinutes || (this.seconds != this.lastSeconds && this.state.type == GAMETYPE_TIME)) {
            this.lastMinutes = minutes;
            this.lastSeconds = seconds;
            this.timeString = minutes + ":" + (seconds < 10 ? "0" : "") + seconds;
        }
    }

    updateScore(state) {
        this.scoreAnim = 0;
        if (this.player1Matches != state.player1.matches) {
            this.scoreAnimZoom = 20;
            this.scoreAnim |= ANIM_PLAYER1_MATCHES;
        }

        if (this.player2Matches != state.player2.matches) {
            this.scoreAnimZoom = 20;
            this.scoreAnim |= ANIM_PLAYER2_MATCHES;
        }

        if (this.scoreAnim == 0) {
            if (this.player1Score != state.player1.score) {
                this.scoreAnimZoom = 20;
                this.scoreAnim |= ANIM_PLAYER1_SCORE;
            }

            if (this.player2Score != state.player2.score) {
                this.scoreAnimZoom = 20;
                this.scoreAnim |= ANIM_PLAYER2_SCORE;
            }
        }

        this.player1Matches = state.player1.matches;
        this.player2Matches = state.player2.matches;
        this.player1Score = state.player1.score;
        this.player2Score = state.player2.score;
        this.player1ScoreString = "" + state.player1.score;
        this.player2ScoreString = "" + state.player2.score;
    }

    render() {
        // Init
        var state = this.state;
        var context = this.context;

        // Save scene transform
        var t = state.projection;
        context.save();
        context.setTransform(t[0], t[1], t[2], t[3], t[4], t[5]);

        // Draw texts
        var s = 30;
        if (state.logic != LOGIC_GAME_INTRO && state.logic != LOGIC_GAME_FINISHED && state.tutorial == undefined) {
            this.renderScore(context, state);
        }

        // Restore scene transform
        context.restore();
    }

    renderScore(context, state) {
        // Init
        var isPointsZoom = false;
        var widthd2 = 130;
        var s = 30;

        //
        if (this.player1ScoreString != undefined) {
            isPointsZoom = this.scoreAnimZoom > 0 && (this.scoreAnim & ANIM_PLAYER1_SCORE) == ANIM_PLAYER1_SCORE;
            if (isPointsZoom) {
                s = 30 + (this.scoreAnimZoom / 20) * (Math.cos(this.scoreAnimZoom) * 10);
            }

            this.renderText(context, this.player1ScoreString, -widthd2 + 10, -95 + s, s, Align.LEFT, this.paintFont);
        }

        s = 30;
        if (this.player2ScoreString != undefined) {
            isPointsZoom = this.scoreAnimZoom > 0 && (this.scoreAnim & ANIM_PLAYER2_SCORE) == ANIM_PLAYER2_SCORE;
            if (isPointsZoom) {
                s = 30 + (this.scoreAnimZoom / 20) * (Math.cos(this.scoreAnimZoom) * 10);
            }

            this.renderText(context, this.player2ScoreString, widthd2 - 10, -95 + s, s, Align.RIGHT, this.paintFont);
        }

        if (state.type == GAMETYPE_BEST_OF) {
            //
            context.save();
            context.translate(-widthd2 + 40, -90);
            isPointsZoom = this.scoreAnimZoom > 0 && (this.scoreAnim & ANIM_PLAYER1_MATCHES) == ANIM_PLAYER1_MATCHES;
            if (isPointsZoom) {
                s = 1 + (this.scoreAnimZoom / 20) * (Math.cos(this.scoreAnimZoom) * 0.75);
                context.scale(s, s);
            }

            for (var i = 0; i < 3; i++) {
                this.drawableScore.alpha = state.player1.matches > i ? 1 : 0.25;
                this.drawableScore.draw(context);
                context.translate(10, 0);
            }

            context.restore();

            //
            context.save();
            context.translate(widthd2 - 40, -90);
            isPointsZoom = this.scoreAnimZoom > 0 && (this.scoreAnim & ANIM_PLAYER2_MATCHES) == ANIM_PLAYER2_MATCHES;
            if (isPointsZoom) {
                s = 1 + (this.scoreAnimZoom / 20) * (Math.cos(this.scoreAnimZoom) * 0.75);
                context.scale(s, s);
            }

            for (var i = 0; i < 3; i++) {
                this.drawableScore.alpha = state.player2.matches > i ? 1 : 0.25;
                this.drawableScore.draw(context);
                context.translate(-10, 0);
            }

            context.restore();
        }

        if (this.timeString != undefined && state.type == GAMETYPE_TIME) {
            s = 20;
            this.renderText(context, this.timeString, 0, -95 + s, s, Align.CENTER, state.time > 4000 ? this.paintFont : this.paintFontSelected);
        }

        if (this.matchballAnim > 0) {
            s = 30;
            var scale = 1 + Math.cos(this.t / 2) * 0.2;
            context.save();
            context.scale(scale, scale);
            this.renderText(context, this.matchball, 0, s / 2, s, Align.CENTER, this.paintFont);
            context.restore();
        }
    }

    renderText(context, str, x, y, s, align, paint) {
        context.save();
        context.textAlign = align;
        context.textBaseline = "bottom";
        context.font = s + "px 'Londrina Solid'";

        if (paint == undefined) {
            paint = this.paintFont;
        }

        if (paint.fillColor != undefined) {
            context.fillStyle = paint.fillColor;
        }

        if (paint.strokeColor != undefined) {
            context.strokeStyle = paint.strokeColor;
        }

        if (paint.strokeWidth != undefined) {
            context.lineWidth = s * 0.05;
        }

        context.fillText(str, x, y);
        if (paint.strokeWidth != undefined) {
            context.strokeText(str, x, y);
        }

        context.restore();
    }
}
